import React from 'react'
import PropTypes from 'prop-types';
import { Bar, Line } from 'react-chartjs-2';
import {
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Popover, PopoverBody, PopoverHeader,
} from 'reactstrap';

IndicatorCard.propTypes = {
  bgcolor: PropTypes.string,
  count: PropTypes.string,
  label: PropTypes.string,
}
IndicatorCard.defaultProps = {
  bgcolor: '',
  count: '',
  label: '',
  icon: '',
};

function IndicatorCard(props) {
  // props.indicatorcount
  // props.indicatorlabel
  // props.indicatorbgcolor
  let chart;
  if (props.chartType === "bar") {
    chart = <Bar data={props.chartData} options={props.chartOption} height={props.height} />
  } else if (props.chartType === "line") {
    chart = <Line data={props.chartData} options={props.chartOption} height={props.height} />
  }
  // else if(props.chartType === "bar"){
  //     chart = <Line data={props.chartData} options={props.chartOption} height={80} />
  // }

  function showInfoBox() {
    props.onInfobtnClick(props.label)
  }

  function hideInfoBox() {
    props.onInfobtnClick()
  }

  return (
    <div className=" text-center">
      <div className="indicatorHover">
        <a disabled={props.disabled}>
          <div className="text-white indicator-card" style={{ backgroundColor: props.bgcolor, cursor: props.hover }} onClick={props.onClick}>
            <span className="clickindicator">
              <CardBody className="p-3" >
                <div className="row">
                  <div className="width-60">
                    <div className="row no-gutters p-3" >
                      <div className="col-md-12 text-value text-left">{props.count}</div>
                      <div className="col-md-12 info-text">
                        <div className="width-auto float-left ">
                          {props.label}
                        </div>
                        <div className="width-auto text-left">   <button
                          id={props.popoverId}
                          className=" btn btn-outline-none  btn-link"
                          style={{ color: '#e9f3f7' }}
                          onMouseEnter={showInfoBox}
                          onMouseLeave={hideInfoBox}
                        >
                          <icon className="icon-inform" aria-hidden="true"></icon>
                        </button>
                          <Popover placement="bottom"
                            isOpen={props.popoverOpen === props.label ? true : false}
                            target={props.popoverId}
                          >
                            <PopoverHeader>Description :</PopoverHeader>
                            <PopoverBody>{props.popoverDesp}</PopoverBody>
                          </Popover>
                        </div> </div></div>
                  </div>
                  <div className="width-40"> <ButtonGroup className="float-right">
                    {/* <i className={`fa ${props.icon} mt-8`} style={{ fontSize: 40 }}></i> */}
                    <i className={`icon-${props.icon} mt-8`} style={{ fontSize: 80 }}></i>
                  </ButtonGroup>
                  </div>

                </div>
             </CardBody>
            </span>
            <div className="chart-wrapper">
              {chart}
            </div>
          </div>
        </a>
      </div>
    </div>
  )
}

export default IndicatorCard
